import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import i18n from 'react-intl-universal';
import errorImage from '../../../assets/images/dummy-error-image.jpg';
import styles from './styles';
import AuthTemplate from '../AuthTemplate';

class ErrorPage extends Component {
  render() {
    const { classes, title, body } = this.props;
    return (
      <AuthTemplate>
        <div className={classes.formItemWrapper}>
          <Typography variant="title">{title}</Typography>
        </div>
        <div className={classes.formItemWrapper}>
          <Typography variant="body1">{body}</Typography>
        </div>

        <div className={classes.gifContainer}>
          <img className={classes.gif} src={errorImage} alt="sorry" />
        </div>
        <div className={classes.resendConfirmationButtonDiv}>
          <Link to="/" className={classes.link}>
            <Typography variant="caption" color="secondary">
              {i18n.get('app.ErrorPage.homepageLink')}
            </Typography>
          </Link>
        </div>
      </AuthTemplate>
    );
  }
}

export default withStyles(styles)(ErrorPage);
